export default __webpack_public_path__ + "static/media/bf.1a7a4f33.svg";